import { NgModule } from '@angular/core';
import { provideRouter, withEnabledBlockingInitialNavigation, RouterModule } from '@angular/router';
import { CoreEffects } from '@next/core-lib';
import { coreRoutes, provideAgrCore } from '@next/core-lib/app';
import { I18nBrowserEffects } from '@next/core-lib/browser';
import { I18nEffects } from '@next/core-lib/i18n';
import { NavigationEffects } from '@next/core-lib/navigation';
import { provideAgrRouterStore } from '@next/core-lib/router-store';
import { SiteEffects } from '@next/core-lib/site';
import { AgrWrapperSiteSidenavModule } from '@next/core-lib/wrapper-site-sidenav';

import { provideEffects } from '@ngrx/effects';
import { provideStore } from '@ngrx/store';

import { AppComponent } from './app.component';
import { appRoutes } from './app.routes';
import { SharedModule } from './shared/shared.module';
import { SoilAnalysisModule } from './soil-analysis/soil-analysis.module';
import { SoilAnalysisEffects } from './soil-analysis/store/soil-analysis.effects';
import { AppEffects } from './store/effects';
import { appReducer } from './store/reducer';
@NgModule({
  declarations: [AppComponent],
  imports: [
    RouterModule,
    SharedModule,
    SoilAnalysisModule,
    AgrWrapperSiteSidenavModule,
  ],
  providers: [
    provideRouter([...appRoutes, ...coreRoutes], withEnabledBlockingInitialNavigation()),
     provideStore(
      { app: appReducer },
      {
        runtimeChecks: {
          strictStateImmutability: true,
          strictActionImmutability: true,
          strictStateSerializability: true,
          strictActionSerializability: true,
        },
      },
    ),
    provideAgrRouterStore(),
    provideAgrCore(),
    provideEffects([
      CoreEffects,
      I18nEffects,
      I18nBrowserEffects,
      SiteEffects,
      NavigationEffects,
      AppEffects,
      SoilAnalysisEffects,
    ]),
  ],
})
export class AppModule {}
